import { useTranslate } from "@refinedev/core";
import { ConfigProvider, Flex, Typography } from "antd";
import {
  MAXIMUM_STORYBOARD_VIDEO_DURATION,
  SPEECH_WORDS_PER_MINUTE,
} from "pages/media/constants";
import { secToHHMMSS } from "pages/media/utils";
import { StyledDurationSlider } from "../styles";

export function ProjectSettingsFormDuration<T>(
  props: Readonly<{
    value: T | undefined;
    onChange: (value: T) => void;
  }>
) {
  const t = useTranslate();

  return (
    <div style={{ marginTop: 50, marginBottom: 0 }}>
      <ConfigProvider
        theme={{
          components: {
            Slider: {
              handleSize: 24,
              handleSizeHover: 28,
              railSize: 20,
              dotSize: 24,
              handleLineWidth: 5,
            },
          },
        }}
      >
        <Flex justify="center" style={{ margin: 10 }}>
          <StyledDurationSlider
            value={props.value as number}
            max={MAXIMUM_STORYBOARD_VIDEO_DURATION}
            min={30}
            step={10}
            onChange={(value) => props.onChange(value as T)}
            tooltip={{
              placement: "top",
              color: "transparent",
              showArrow: false,
              getPopupContainer: (triggerNode) => {
                return triggerNode;
              },
              styles: {
                root: {
                  borderRadius: 10,
                  userSelect: "none",
                },
              },
              open: true,
              formatter: (value) => (
                <Flex
                  vertical
                  style={{
                    textAlign: "center",
                    padding: "5px 20px",
                  }}
                >
                  <Typography.Text style={{ fontSize: 20 }} type="secondary">
                    {value ? secToHHMMSS(value) : ""}
                  </Typography.Text>
                  {value && (
                    <Typography.Text type="secondary">
                      ≈ {Math.floor((value / 60) * SPEECH_WORDS_PER_MINUTE)}{" "}
                      {t("projects.components.ProjectSettingForm.words")}
                    </Typography.Text>
                  )}
                </Flex>
              ),
            }}
          />
        </Flex>
      </ConfigProvider>
    </div>
  );
}
